import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { CONTRACTS } from '../apiUrls';

const mutationAddContracts = (onSuccess, onError) => {
    return {
        mutationFn: ({ merchantAccountUuid, contracts }) => {
            return client.post(replaceParameters(CONTRACTS.UPDATE.url, { contractAccessId: merchantAccountUuid }), contracts);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddContracts;